<template>
  <v-dialog v-model="dialog" max-width="480">
    <template v-slot:activator="{ on }">
      <v-btn color="brown darken-1 ml-1" dark v-on="on"> Приостановить</v-btn>
    </template>

    <v-card class="elevation-12" :loading="loading">
      <v-card-title class="headline"> Подтвердите приостановление</v-card-title>
      <v-card-text>
        <v-textarea v-model="comment" outlined :dense="true" label="Комментарий" no-resize row-height="12" clearable :disabled="loading"/>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" dark @click="dialog = false" :disabled="loading" text> Закрыть</v-btn>
        <v-spacer/>
        <v-btn color="brown darken-1" dark @click="onStopClicked" :disabled="loading" text> Приостановить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import ReturnOrderService from "@/services/return.order.service";

export default {
  name: "StopReturnOrder",
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      comment:""
    }
  },
  methods: {
    onStopClicked() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.loading = true
      const data = {
        Comment:this.comment
      }
      ReturnOrderService.stopOrder(this.id, data)
          .then(() => {
            this.dialog = false
            this.$emit("stopped")
          })
          .catch((exception) => {
            window.console.log(exception)
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  }
}
</script>

<style scoped>

</style>